import { initials } from '@/shared/lib/format';
import { cn } from '@/shared/lib/cn';

interface InitialsAvatarProps {
  name: string;
  /** Cor de fundo do passbook (a mesma do cabeçalho). Sem ela, círculo neutro. */
  backgroundColor?: string;
  /** Cor do texto do passbook (`foregroundColor` / `labelColor`). */
  color?: string;
  className?: string;
}

/**
 * Avatar de iniciais gerado no próprio navegador. Sem chamada à API do DiceBear:
 * o nome não sai para terceiros. O fundo segue o passbook, igual ao tema da página.
 */
export function InitialsAvatar({ name, backgroundColor, color, className }: InitialsAvatarProps) {
  const text = initials(name) || '?';
  const onColor = Boolean(backgroundColor);
  return (
    <span
      role="img"
      aria-label={name}
      className={cn(
        'relative grid size-12 shrink-0 select-none place-items-center overflow-hidden rounded-full text-lg font-semibold shadow-soft ring-2 ring-background',
        !onColor && 'bg-muted text-foreground',
        className,
      )}
      style={
        onColor
          ? { backgroundColor, color: color || '#fff' }
          : undefined
      }
    >
      {/* Brilho em degradê radial DENTRO do círculo. Nada de `blur` aqui: o Safari (iOS) não recorta filtro pelo
          arredondado e o brilho vazava como um quadrado cinza em volta do avatar (visível no modo escuro). */}
      <span className="pointer-events-none absolute inset-0 rounded-full bg-[radial-gradient(circle_at_30%_25%,rgba(255,255,255,0.32),transparent_60%)]" />
      <span className="relative tracking-wide">{text}</span>
    </span>
  );
}
